export default {
  props: {
    policyId: {
      type   : String,
      default: ''
    }
  },
  computed: {
    id () {
      return this.policyId || this.$route.params.id
    }
  }
}
